export const ORQUESTADOR_ACCESS_STORAGE_KEY = 'orquestadorMahouAccessV2';
export const ORQUESTADOR_SESSION_USER_STORAGE_KEY = 'orquestadorMahouSessionUserV2';
export const ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY = 'orquestadorMahouAccessTokenV1';
export const ORQUESTADOR_REFRESH_TOKEN_STORAGE_KEY = 'orquestadorMahouRefreshTokenV1';
export const ORQUESTADOR_GROUPS_STORAGE_KEY = 'orquestadorMahouGroupsV1';
const LEGACY_SESSION_STORAGE_KEYS = [
  'orquestadorMahouAccess',
  'orquestadorMahouSessionUser',
];

export const ORQUESTADOR_USERNAMES = {
  MSM_FULL: 'Prueba Usuario',
  MSM_STEEL: 'MSM.Steel',
  GXO: 'Prueba Usuario GXO',
};

export const ORQUESTADOR_ACCESS_LEVELS = {
  FULL: 'full',
  MSM_STEEL: 'msm-steel',
  CONTROL_GESTION: 'control-gestion',
};

export const ORQUESTADOR_AUTH_API_BASE_URL = (
  process.env.REACT_APP_ORQUESTADOR_AUTH_API_BASE_URL
  || 'https://orquestador-steel-django-e50065afec07.herokuapp.com'
).replace(/\/$/, '');

export const ORQUESTADOR_ROUTES = {
  GLOBAL: '/OrquestadorMahou/global',
  GOBIERNO: '/OrquestadorMahou/gobierno',
  OPERATIVO: '/OrquestadorMahou/operativo',
  PROYECCION_RECURSOS: '/OrquestadorMahou/proyeccion-recursos',
  CONTROL_GESTION: '/OrquestadorMahou/control-gestion',
  DATA_IA: '/OrquestadorMahou/data-ia',
  LOGIN: '/OrquestadorMahou/login',
};

export const DEFAULT_AUTHENTICATED_ROUTE = ORQUESTADOR_ROUTES.GLOBAL;

export const ORQUESTADOR_AUTHENTICATED_ROUTES = [
  ORQUESTADOR_ROUTES.GLOBAL,
  ORQUESTADOR_ROUTES.GOBIERNO,
  ORQUESTADOR_ROUTES.OPERATIVO,
  ORQUESTADOR_ROUTES.PROYECCION_RECURSOS,
  ORQUESTADOR_ROUTES.CONTROL_GESTION,
  ORQUESTADOR_ROUTES.DATA_IA,
];

export const ORQUESTADOR_GROUP_ROUTE_ACCESS = {
  [ORQUESTADOR_ACCESS_LEVELS.FULL]: ORQUESTADOR_AUTHENTICATED_ROUTES,
  [ORQUESTADOR_ACCESS_LEVELS.MSM_STEEL]: [
    ORQUESTADOR_ROUTES.GLOBAL,
    ORQUESTADOR_ROUTES.GOBIERNO,
    ORQUESTADOR_ROUTES.OPERATIVO,
    ORQUESTADOR_ROUTES.PROYECCION_RECURSOS,
  ],
  [ORQUESTADOR_ACCESS_LEVELS.CONTROL_GESTION]: [
    ORQUESTADOR_ROUTES.CONTROL_GESTION,
  ],
};

function parseStoredGroups(groups) {
  if (!groups) {
    return [];
  }

  try {
    const parsedGroups = JSON.parse(groups);

    if (!Array.isArray(parsedGroups)) {
      return [];
    }

    return parsedGroups.filter((group) => typeof group === 'string');
  } catch {
    return [];
  }
}

function normalizeGroup(group) {
  return String(group || '').trim().toLowerCase();
}

export function sessionHasGroup(session, group) {
  const targetGroup = normalizeGroup(group);

  return Boolean(session?.groups?.some((sessionGroup) => normalizeGroup(sessionGroup) === targetGroup));
}

export function getRecognizedGroups(groups = []) {
  const knownGroups = Object.keys(ORQUESTADOR_GROUP_ROUTE_ACCESS);
  const normalizedGroups = groups.map(normalizeGroup).filter((group) => knownGroups.includes(group));

  return Array.from(new Set(normalizedGroups));
}

export function getAccessLevelFromGroups(groups = []) {
  const recognizedGroups = getRecognizedGroups(groups);

  if (recognizedGroups.includes(ORQUESTADOR_ACCESS_LEVELS.FULL)) {
    return ORQUESTADOR_ACCESS_LEVELS.FULL;
  }

  return recognizedGroups[0] || null;
}

export function getAllowedRoutesFromGroups(groups = []) {
  const allowedRoutes = getRecognizedGroups(groups)
    .flatMap((group) => ORQUESTADOR_GROUP_ROUTE_ACCESS[group]);

  return ORQUESTADOR_AUTHENTICATED_ROUTES.filter((route) => allowedRoutes.includes(route));
}

export function getAllowedRoutesForSession(session) {
  if (!session) {
    return [];
  }

  const allowedRoutesFromGroups = getAllowedRoutesFromGroups(session.groups);

  if (allowedRoutesFromGroups.length > 0) {
    return allowedRoutesFromGroups;
  }

  if (session.access && ORQUESTADOR_GROUP_ROUTE_ACCESS[normalizeGroup(session.access)]) {
    return getAllowedRoutesFromGroups([session.access]);
  }

  return [];
}

export function canAccessOrquestadorRoute(session, route) {
  return getAllowedRoutesForSession(session).includes(route);
}

export function getDefaultRouteForSession(session) {
  return getAllowedRoutesForSession(session)[0] || null;
}

export function getOrquestadorSession(storage = window.localStorage) {
  const access = storage.getItem(ORQUESTADOR_ACCESS_STORAGE_KEY);
  const username = storage.getItem(ORQUESTADOR_SESSION_USER_STORAGE_KEY);
  const accessToken = storage.getItem(ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY);
  const refreshToken = storage.getItem(ORQUESTADOR_REFRESH_TOKEN_STORAGE_KEY);
  const groups = parseStoredGroups(storage.getItem(ORQUESTADOR_GROUPS_STORAGE_KEY));

  if (!access || !username) {
    return null;
  }

  return {
    access,
    username,
    accessToken,
    refreshToken,
    groups,
  };
}

export function storeOrquestadorSession(sessionOrUsername, access, storage = window.localStorage) {
  const session = typeof sessionOrUsername === 'object'
    ? sessionOrUsername
    : {
      username: sessionOrUsername,
      access,
      groups: access ? [access] : [],
    };
  const groups = Array.isArray(session.groups) ? session.groups : [];
  const nextAccess = session.access || getAccessLevelFromGroups(groups);

  LEGACY_SESSION_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
  if (nextAccess) {
    storage.setItem(ORQUESTADOR_ACCESS_STORAGE_KEY, nextAccess);
  } else {
    storage.removeItem(ORQUESTADOR_ACCESS_STORAGE_KEY);
  }
  storage.setItem(ORQUESTADOR_SESSION_USER_STORAGE_KEY, session.username);
  storage.setItem(ORQUESTADOR_GROUPS_STORAGE_KEY, JSON.stringify(groups));

  if (session.accessToken) {
    storage.setItem(ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY, session.accessToken);
  } else {
    storage.removeItem(ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY);
  }

  if (session.refreshToken) {
    storage.setItem(ORQUESTADOR_REFRESH_TOKEN_STORAGE_KEY, session.refreshToken);
  } else {
    storage.removeItem(ORQUESTADOR_REFRESH_TOKEN_STORAGE_KEY);
  }
}

export function clearOrquestadorSession(storage = window.localStorage) {
  LEGACY_SESSION_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
  storage.removeItem(ORQUESTADOR_ACCESS_STORAGE_KEY);
  storage.removeItem(ORQUESTADOR_SESSION_USER_STORAGE_KEY);
  storage.removeItem(ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY);
  storage.removeItem(ORQUESTADOR_REFRESH_TOKEN_STORAGE_KEY);
  storage.removeItem(ORQUESTADOR_GROUPS_STORAGE_KEY);
}

export function hasMsmSteelRestrictions(session) {
  return Boolean(session)
    && getAccessLevelFromGroups(session.groups || [session.access]) === ORQUESTADOR_ACCESS_LEVELS.MSM_STEEL
    && !sessionHasGroup(session, ORQUESTADOR_ACCESS_LEVELS.FULL);
}

export function hasControlGestionAccess(session) {
  return Boolean(session)
    && canAccessOrquestadorRoute(session, ORQUESTADOR_ROUTES.CONTROL_GESTION)
    && getAllowedRoutesForSession(session).length === 1;
}
